export default {
	default:{
		submit:"Submeta ",
		SendVerificationCode:"Envie código",
		VerificationCode:"Código de verificação ",
		VerificationCodeTip:"Digite o código de verificação ",
		MessageAuthenticationCode:"Código de verificação por SMS ",
		EmailAuthenticationCode:'Código de verificação de email ',
		VerificationCodeError:'Erro de entrada do código de verificação ',
		PasswordsNotMatch:"As senhas digitadas duas vezes são inconsistentes ",
		PasswordChangeSuccess:"A senha foi alterada. ",
		PasswordError:"Senha incorreta ",
		CNY:'Yuan ',
		USD:'USD ',
		TRY:'Lira turca ',
		Notice:"Dica ",
		Done:'Confirme ',
		ErrorSendingEmail:'Falha no envio do código de verificação de e-mail. Verifique se seu endereço de e-mail está errado ',
		SuccessSendingEmail:'O código de verificação de email foi enviado, verifique seu email ',
		ErrorSendingMessage:'Falha no envio do código de verificação por SMS. Verifique se o número do seu celular foi inserido incorretamente ',
		SuccessSendingMessage:'O código de verificação SMS foi enviado, confirme ',
		Resend:'Reenviar ',
		EmailCodeErr:'código de verificação de e-mail incorreto',
		ImgCodeErr:'imagem captcha incorreto',
		MessageCodeErr:'código de verificação SMS incorreto'
	},
	nav:{
		UserCenter:'Central do usuário ',
		MyAccount:'Minha conta ',
		SecurityCenter:'Centro de segurança ',
		ChangePassword:'Alteração de senha ',
		RealNameAuthentication:'Autenticação de nome real ',
		Phone:'Vinculação e modificação do celular ',
		Email:'Vinculação e modificação de email ',
		SecurityQuestion:'Questões de segurança ',
		VoucherCenter:'Central de recarga ',
		GameRecharge:'Recarga de jogo ',
		RechargeHistory:'Registro de recarga ',
        AccountComplaint:'apelo de anomalia na conta ',
        ThirdAccount: 'Conta de terceiros'
	},
	header:{
		Login:"Login ",
		Logout:"Eliminar ",
		GameLists:"Lista de jogos ",
		UserCenter:"Central do usuário ",
		SecurityCenter:"Centro de segurança ",
		VoucherCenter:"Central de recarga ",
		CustomerServiceCenter:"Central do cliente ",
		Language:"Mudar idioma ",
		CurrentPosition:"Posição atual ",
	},
	games:{
		battleTeams1:"Battle Teams 1 ",
		battleTeams2:"Battle Teams 2 ", 
		battleTeamsMobile:"Jogo Battle Teams no celular ",
	},
	home:{
		AccountInformation:"Informações da conta ",
		UserName:"Nome de usuário ",
		Nickname:"Apelido ",
		TheLatestLoginDate:"Hora do último login ",
		SecurityLevel:"Nível de segurança ",
		SecurityTip:"Para segurança da conta, recomendamos que você ative as seguintes configurações ",
		Change:"Modificar ",
		Bind:"Vincular ",
		Setting:"Configurar ",
		Submitted:"Submetido ",
		Bound:"Vinculado ",
		Set:"Configurado ",
		Unsubmitted:"Não enviado ",
		Unbound:"Não vinculado ",
		Notset:"Não definido ",
		PasswordLevel:"Nível de senha ",
		Security:"Nível de segurança ",
		SecurityLow:'Média ',
		SecurityHigh:'Alta ',
		PasswordLevelLow:"O nível da sua senha é médio, é recomendável modificar ",
		PasswordLevelHigh:"O nível da sua senha é alto ",
		PersonalInformation:"Informações sobre o nome real ",
		RealNameTip:"É usado principalmente para autenticação anti-vício de conta e é uma evidência importante para apelo à conta. ",
		MobilePhonebinding:"Vincule ao celular ",
		SecurityQuestionTip:"É facilitar a modificar funções importantes relacionadas, como senhas ",
		Emailbinding:"Vincule email ",
		SecurityQuestion:"Questões de segurança ",
		NicknameTip:'Digite um apelido ',
		NicknameSet:'O apelido foi definido '
	},
	password:{
		ChangePassword:"Alteração de senha ",
		CurrentPassword:"Senha original ",
		CurrentPasswordTip:"Digite a senha original ",
		NewPassword:"Nova senha ",
		NewPasswordTip:"Digite uma nova senha ",
		ConfirmPassword:"Confirme senha ",
		ConfirmPasswordTip:"Digite a senha novamente ",
		ForgotPassword:"Esqueceu sua senha? Recupere senha ",
		PasswordsNotMatch:"As senhas digitadas duas vezes são inconsistentes ",
		PasswordChangeSuccess:"A senha foi alterada. ",
		OldPasswordError:"Senha antiga incorreta ",
		NewPasswordSameAsOldPassword:"Senhas nova e antiga não podem ser as mesmas ",
		SetPassword:'Defina a senha.'
	},
	forgot:{
		RecoverPassword:"Recuperação de senha ",
		RecoverPasswordTip:"Há três maneiras de recuperar a senha: se houver outros problemas, entre no centro de atendimento ao cliente para obter assistência manual. ",
		SecurityMobilePhone:"Celular confidencial ",
		SecurityEmail:"Email confidencial ",
		SecurityQuestion:"Questões de segurança ",
		UserName:"Nome de usuário ",
		SecurityQuestion:"Questões de segurança ",
		SecurityAnswer:"Resposta de segurança ",
		SecurityAnswerTip:"Digite a resposta de segurança ",
		SecurityAnswerError:"Resposta de segurança errada ",
		NewPassword:"Nova senha ",
		NewPasswordTip:"Digite uma nova senha ",
		ConfirmPassword:"Confirme senha ",
		NewPasswordAgainTip:"Digite a senha novamente ",
		PhoneTip:"Digite o número de celular ",
		VerificationCode:"Código de verificação ",
		VerificationCodeTip:"Digite o código de verificação ",
		SendVerificationCode:"Envie código",
		EmialTip:"Digite o email ",
		Confirmation:"Confirme ",
		PasswordsNotMatch:"As senhas digitadas duas vezes são inconsistentes ",
		PasswordChangeSuccess:"A senha foi alterada. ",
		NotBoundPhone:'Você não vinculou seu número de celular ',
		NotBoundEmail:'Você não vinculou seu email ',
		NotSetQuestion:'Você não configurou uma pergunta de segurança ',
	},
	realName:{
		Name:"Nome ",
		NameTip:"Digite seu nome real ",
		IDCard:"Carteira de identidade ",
		IDCardTip:"Digite o número de identificação ",
		SetRealnameSuccess:"O nome real foi autenticado ",
		ModifyTip:'Modifique as informações de autenticação de nome real, entre em contato com o atendimento ao cliente no centro de atendimento ao cliente ',
		ReCertification:'Recertificação',
		SetRealnameFail:'Autenticação falhou, por favor, insira informações pessoais correspondentes',
		MisMatch:'As informações de autenticação não correspondem, por favor, insira novamente '
	},
	phone:{
		MobilePhonebinding:"Vinculação ao celular ",
		MobilePhoneNumber:"Número de celular ",
		MobilePhoneNumberTip:"Digite o número de celular ",
		VerificationCode:"Código de verificação ",
		VerificationCodeTip:"Digite o código de verificação ",
		SuccessTip:"Status das configurações da vinculação do celular: ",
		BoundtoMobilephone:"Celular vinculado ",
		ChangetheMobilephone:"Modificar celular ",
		UnbindtheMobilephone:"Desvincular celular ",
		Phonelossorabnormity:"Celular perdido ou anormal? ",
		MessageAuthenticationCode:"Código de verificação por SMS ",
		NewBindPhone:'Novo telefone ligado',
		BindingNewPhone:'Ligar novo telefone',
		Next:'Próximo passo',
		CheckOldPhone:'Verifique o telefone original',
		HadBindOther:'O telefone está ligado a outra conta',
		PleaseCheckOldPhone:'Verifique primeiro o número de telefone original'
	},
	email:{
		Email:'Email ',
		EmailTip:"Digite o email ",
		Emailbinding:"Vinculação de email ",
		SuccessTip:"Status da configuração do email vinculado: ",
		BoundtoEmail:"Email vinculado ",
		ChangetheEmail:"Modificar Email ",
		UnbindtheEmail:"Desvincular Email ",
		Emaillossorabnormity:"O email está ausente ou está anormal? ",
		UnbindingEmailSuccessfully:"O Email foi desvinculado ",
		EmailFormat:'Erro no formato da Email '
	},
	question:{
		SecurityQuestion:"Questões de segurança ",
		SecurityAnswer:"Resposta da pergunta ",
		SecurityAnswerTip:"Insira a resposta da pergunta ",
		ConfirmAnswer:"Confirme a resposta ",
		ConfirmAnswerTip:"Digite a resposta da pergunta novamente ",
		SetQuestionSuccess:"A pergunta de segurança foi definida. ",
		QuestionNotMatch:"Respostas de segurança duas vezes foram inconsistentes ",
		AnswerLength:'O comprimento da resposta de segurança não pode exceder 20 dígitos ',
	},
	complaint:{
		ComplaintCon:'Quando você não pode modificar as informações da verificação do celular ou do e-mail, pode fornecer informações válidas, como o cartão de identificação usado para autenticação de nome real (observe que isso deve ser submetido), 2-3 registros de recarga de conta válidos e outras informações válidas são enviadas ao email oficial kf@wooduan.com, processará dentro de 3 a 7 dias úteis e retornará as informações de processamento ao seu email de apelo. '
	},
	charge:{
		OnlineBank:"Banco online ",
		RechargeAccount:"Conta de recarga ",
		ChoseGame:"Escolha um jogo ",
		ChoseServer:"Selecione serviço distrital ",
		ServerSlt:"Selecione seu jogo e servidor! ",
		RechargeAmount:"Valor de recarga ",
		AmountTip:"Digite outro valor ",
		BanksTip:"Selecione banco ",
		MoreBanks:"Selecione mais bancos ",
		Overview:"Visão geral ",
		Game:"Jogo ",
		Server:"Serviço distrital ",
		Price:"Valor do pagamento ",
		Confirmthepayment:"Confirme pagamento ",
		SuccessTip:"Parabéns, a recarga foi feita. ",
		OrderInformation:"Informações sobre pedido ",
		RechargeAccount:"Conta de recarga ",
		TopupGame:"Jogo de recarga ",
		Rechargeserver:"Serviço de recarga ",
		Paymentmethod:"Canal de recarga ",
		TotalrechargeAmount:"Valor total de recarga ",
		Topupagain:"Recarregar ",
		RechargeHistory:"Registro de recarga ",
		GoldAmount:"{gold}Moedas de ouro ",
		MoneyAmount:"{money} Yuan ",
		PayWithWeixin:'Use o WeChat para digitalizar o código QR para pagar ',
		TopupSuccessfully:"A recarga foi feita. ",
		TopupProblems:"Problemas com recarga ",
		ChoseAmount:"Selecione o valor da recarga ",
		ChoseGameAndRegion:"Selecione jogo e serviço distrital ",
		ChoseChargeType:"Selecione o modo de recarga ",
		TopupFailTip:'Falha na recarga, envie novamente ',
		TopupFailNeedService:"Falha na recarga, entre em contato com o atendimento ao cliente {msg}",

		OrderNumber:'Número do pedido ',
		RedeemCode:'Código de troca ',
		Topup:'Mercadorias de recarga ',
		ConfirmThePayment:'Confirme a recarga ',
		TenAmount:'Recarga de valor personalizado (insira um múltiplo de 10) ',
		Unknown:'Desconhecido ',
		Unpaid:'Não remunerado ',
		Recharging:'Recarregando ',
		RechargeSuccessful:'A recarga foi feita. ',
		RechargeFailed:'Falha na recarga ',
		CancelTheRecharge:'Cancelar recarga ',
		Refunded:'Reembolsado ',
		CancelTheRefund:'Cancelar reembolso ',
		RefundFailed:'Falha no reembolso ',
		Refunding:'Reembolsando ',
		NewOrder:'novo pedido',
		StyleDeal:'pendente',
		Dealing:'em processamento',
		Expired:'expirado',
		Checking:'em revisão',
		Provider:'Entidade pagadora'
	},
	chargeHistory:{
		LastWeek:"Última semana ",
		LastMonth:"Último mês ",
		HistoricalRecharge:"Histórico de recarga ",
		QueryRange:"Intervalo de consulta ",
		Selectgames:"Escolha um jogo ",
		Pleaseselectagame:"Selecione um jogo ",
		Inquire:"Consulta ",
		Time:"Hora ",
		Account:"Conta ",
		GameServer:"Serviço distrital de jogo ",
		Paymentmethod:"Canal de recarga ",
		PaymentAmount:"Valor do pagamento ",
		Status:"Status ",
		Totalamount:"Valor total de recarga ",
		Totalitems:"Total de {itens} ",
	},
	login:{
		Login:"Login da passagem da Wooduan ",
		AccountLabel:"Nome de usuário/número de celular/email ",
		PasswordLabel:"Senha ",
		ConfirmPassword:'Confirme senha ',
		ConfirmPasswordLabel:'Confirme senha ',
		LoginBtn:"Login imediato ",
		RegisterBtn:'Inscreva-se agora ',
		RegisterLink:"Não tem conta? Inscreva-se agora ",
		LoginLink:'Já tem uma conta? Login imediato ',
		ForgotLink:"Esqueci a senha ",
		QuickLogin:"Acesso rápido ",
		Register:'Registro da passagem da Wooduan ',

		RecoverByPhone:"Recuperação de senha do celular de segurança ",
		RecoverByQuestion:"Recuperação de senha da pergunta de segurança ",
		RecoverByEmail:"Recuperação de senha do email de segurança ",
		Phone:"Número de celular ",
		UserName:"Nome de usuário ",
		ResetPassword:"Redefine senha ",
		RecoverByOther:"Outras maneiras de recuperar sua senha ",
		SecurityEmail:"Email confidencial ",
		SecurityQuestion:'Questões de segurança ',
		SecurityAnswer:'Resposta de segurança ',
		PhoneAccountTip:'Digite o número da sua conta ou número de celular ',
		PasswordTip:'Digite sua senha ',
		PhoneNotReged:'O número de celular não está registrado ',
		AccountNotReged:'A conta não está registrada ',
		LoginFail:'Falha no login, faça login novamente ',
		RegSuccess:'Foi registrado, faça o login ',
		PhonwHasReged:'O número de celular foi registrado ',
		AccountHasReged:'A conta foi usada ',
		RegFail:'Falha no registro, increva-se novamente ',
		EmailHasReged:'Email foi registrado ',
		PasswordErr:'A senha contém pelo menos um número ou letra de 6 a 16 dígitos',
		AccountErr:'O nome do usuário deve começar com uma letra em inglês, exceto chinês, de 4 a 18 dígitos ',
		RegAccountTip:'Digite um nome de usuário',
    },
    third:{
        RemoveBound: 'Desvincular',
         UnbindSuccess: 'Desvincular com êxito',
         ThirdAccountTip: 'Você pode vincular ou desvincular as seguintes contas de terceiros e usar a conta de terceiros para fazer login rapidamente após a ligação',
    },
	bind: {
		head:'vincular conta', 	
                tip:'vincular conta com seu telefone ou email', 	
                bind:'vincular conta agora', 	
                or:'ou', 	
                auto:'criar conta automaticamente', 	
                user:'nome', 	
                password:'senha', 	
                noAccount:'ainda não tem conta e cria conta agora', 	
                hasAccount:'tem conta e vincula agora', 	
                regHead:'criar conta', 	
                regTip:'preenchar as informações de registro por favor', 	
                confirm_password:'confirmar senha', 	
                email:'e-mail', 	
                phone:'telefone', 	
                emailCode:'Código de verificação de email', 	
                phoneCode:'Código de verificação de telefone', 	
                getCode:'Enviar código', 	
                retry:'tentar fazer novamente depois de', 	
                submit:'criar conta agora',  	
                accountTip:'digitar sua conta', 	
                passwordTip:'digitar sua senha', 	
                passwordErr:'a conta deve ter de 6 dígitos a 16 dígitos e pelo menos ter um alfabeto ou um número e não ter caracteres especiais', 	
                confirmTip:'senha não encontrada', 	
                phoneTip:'digitar telefone', 	
                emailTip:'digitar e-mail', 	
                phoneErr:'erro no formulário do telefone', 	
                emailErr:'Erro no formulário do e-mail', 	
                codeTip:'digitar código de validação',
		bindErr:'Falha em vincular. Tente novamente mais tarde',
		confirm:'A certeza',
		cancel:'cancelar',
		return:'regresso',
		PhonwHasReged:'O número de celular foi registrado ',
		AccountHasReged:'A conta foi usada ',
		VerificationCodeError:'Erro de entrada do código de verificação',
		EmailHasReged:'Email foi registrado ',
		ErrorSendingEmail:'Falha no envio do código de verificação de e-mail. Verifique se seu endereço de e-mail está errado ',
		ErrorSendingMessage:'Falha no envio do código de verificação por SMS. Verifique se o número do seu celular foi inserido incorretamente ',
		ParamErr:'Error en los parámetros'
	}
}


